/** Every date is a local day, YYYY-MM-DD; weeks start on Monday. */

function pad(n: number): string {
  return (n < 10 ? "0" : "") + n;
}

export function dayString(d: Date): string {
  return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
}

export function parseDay(s: string): Date {
  const p = String(s).split("-");
  return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 12);
}

export function addDays(s: string, n: number): string {
  const d = parseDay(s);
  d.setDate(d.getDate() + n);
  return dayString(d);
}

export function mondayOf(s: string): string {
  const d = parseDay(s);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return dayString(d);
}

export function todayString(): string {
  return dayString(new Date());
}

const DAY_RE = /^\d{4}-\d{2}-\d{2}$/;
export function isDay(s: unknown): s is string {
  return typeof s === "string" && DAY_RE.test(s) && !isNaN(parseDay(s).getTime());
}

function fmt(s: string, opts: Intl.DateTimeFormatOptions): string {
  return parseDay(s).toLocaleDateString("en-US", opts);
}
export const dayShort = (s: string) => fmt(s, { weekday: "short", month: "short", day: "numeric" });
export const dayLong = (s: string) => fmt(s, { weekday: "long", month: "short", day: "numeric" });
export const monthDay = (s: string) => fmt(s, { month: "short", day: "numeric" });
export const weekdayShort = (s: string) => fmt(s, { weekday: "short" });
export const weekdayLong = (s: string) => fmt(s, { weekday: "long" });

export function weekRange(monday: string, thisYear = new Date().getFullYear()): string {
  const sunday = addDays(monday, 6);
  const a = parseDay(monday);
  const b = parseDay(sunday);
  const right = a.getMonth() === b.getMonth() ? String(b.getDate()) : monthDay(sunday);
  let text = monthDay(monday) + " – " + right;
  if (a.getFullYear() !== b.getFullYear()) text = monthDay(monday) + ", " + a.getFullYear() + " – " + monthDay(sunday) + ", " + b.getFullYear();
  else if (a.getFullYear() !== thisYear) text += ", " + a.getFullYear();
  return text;
}
